import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Layout from './components/Layout';
import Dashboard from './pages/Dashboard';
import Projects from './pages/Projects';
import ProjectDetails from './pages/ProjectDetails';
import RunHistory from './pages/RunHistory';
import SystemResources from './pages/SystemResources';
import CostAnalyticsPage from './pages/CostAnalyticsPage';
import QueryAnalyticsPage from './pages/QueryAnalyticsPage';
import LogAnalyticsPage from './pages/LogAnalyticsPage';


import './App.css';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Navigate to="/dashboard" replace />} />
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="projects" element={<Projects />} />
          <Route path="projects/:projectId" element={<ProjectDetails />} />
          <Route path="projects/:projectId/runhistory" element={<RunHistory />} />
          <Route path="system-resources" element={<SystemResources />} />
          <Route path="cost-analytics" element={<CostAnalyticsPage />} />
          <Route path="query-analytics" element={<QueryAnalyticsPage />} />
          <Route path="log-analytics" element={<LogAnalyticsPage />} />


        </Route>
      </Routes>
    </Router>
  );
}

export default App; 